import React from 'react';
import { Wrapper } from './styles';
export const Overlay = ({ open, onClick }) => {
    return React.createElement(Wrapper, { "data-open": open, onClick: onClick, "data-testid": "mobile-overlay-overflow-menu" });
};
